module.exports = __webpack_public_path__ + "img/easyroll_logo.5569ca84.png";